export { default as Badge, badgeVariants, type BadgeVariant } from './badge.svelte';
